import Cookies from 'js-cookie';
import { _n } from '@wordpress/i18n';

function updateSharedUrls() {
  const parts = [window.location.href, '?ids=', Cookies.get('compare')];
  document.querySelectorAll('[data-share-href]')?.forEach((el) => {
    el.href = el.dataset.shareHref + encodeURI(parts.join(''));
  });
}

document.addEventListener('compare-add', () => {
  updateSharedUrls();
});
document.addEventListener('compare-remove', () => {
  updateSharedUrls();
});

document.addEventListener('DOMContentLoaded', function () {
  updateSharedUrls();
  // document.addEventListener("compare-remove", (e) => {
  // 	if (e.detail.count) {
  // 		document.compareSwipers.forEach((swiper) => {
  // 			swiper.slides.forEach((slide, index) =>
  // 				slide.dataset.sliderId == e.detail.lotID
  // 					? swiper.removeSlide(index)
  // 					: false
  // 			);
  // 		});
  // 	} else {
  // 		this.location.reload();
  // 	}
  // });

  const urlParams = new URLSearchParams(window.location.search);
  const ids = urlParams.get('ids');

  let lotsNotActual = Cookies.get('compare_not_actual_lots');
  lotsNotActual = lotsNotActual ? lotsNotActual.split(',') : [];

  if (ids) {
    let lotsNeeds = [];
    let lotsAll = ids.split(',');
    lotsAll.forEach((lotID) => {
      if (!lotsNotActual.includes(lotID)) {
        lotsNeeds.push(lotID);
      }
    });
    const newUrl = theme.pages.compare.url + '?ids=' + lotsNeeds.join(',');
    history.replaceState(null, null, newUrl);
  }

  if (lotsNotActual.length > 0) {
    const countCurrent = document.querySelector(`[data-type="compare"]`).dataset
      .count;
    const counters = document.querySelectorAll(`[data-type="compare"]`);
    counters.forEach((el) => {
      el.dataset.count = countCurrent - lotsNotActual.length;
      el.parentNode.parentNode.classList.add('tada');
      setTimeout(() => {
        el.parentNode.parentNode.classList.remove('tada');
      }, 1000);
    });

    document.showToastifyMesage(
      _n(
        '%s lot has been removed because it is no longer available',
        '%s lots have been removed because they are no longer available',
        lotsNotActual.length,
        'w8-shipping-front',
      ).replace('%s', lotsNotActual.length),
      'warning',
      3000,
    );
    Cookies.remove('compare_not_actual_lots');
  }
});

// if (theme.page.is_compare) {
//   const newUrl = theme.pages.compare.url;
//   history.replaceState(null, null, newUrl);
// }

// document.addEventListener("compare-add", setCompareUrl);
// document.addEventListener("compare-remove", setCompareUrl);
// document.addEventListener("compare-clear", setCompareUrl);

// function setCompareUrl (event) {
// 	const lotsIdsArray = event.detail.products;

// 	const newUrl = theme.pages.compare.url + (lotsIdsArray.length ? `?ids=${lotsIdsArray.join(",")}` : "");
// 	document.querySelectorAll(`[href^="${theme.pages.compare.url}"]`).forEach((el) => {
// 		el.href = newUrl;
// 	});
// 	if (theme.page.is_compare) {
// 		history.replaceState(null, null, newUrl);
// 	}
// }
